import React, { useEffect, useState } from 'react';
import DeletePeople from '../modals/delete-people-modal';
import { getFullName, handleApiError } from 'utils/functions';
import AddRole from './add-role-modal';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { MemberListType } from 'models/member.model';
import { SideModal } from '@cokitchen/cokitchen-components';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ManageRoleModal = ({ isOpen, onClose }: Props) => {
  const { activeCompany } = useDashboardContext();
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [adminList, setAdminList] = useState<MemberListType[]>([]);
  const [loading, setLoading] = useState(false);
  const [activeAdmin, setActiveAdmin] = useState({} as any);

  const companyId = activeCompany?.id;

  useEffect(() => {
    if (companyId) fetchAdminList();
  }, [companyId]);
  const fetchAdminList = async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const res = await apiService.get('member', { params: { company_id: companyId } });
      const { data } = res.data;
      const adminList = data?.results?.filter((item: any) => item.role === 'ADMIN');
      setAdminList(adminList);
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const updateAdminList = (newData: MemberListType[]) => {
    setAdminList(adminList.concat(newData));
  };

  const removeAdmin = () => {
    setShowRemoveModal(!showRemoveModal);
  };
  const addRoleModal = () => {
    setShowAddModal(!showAddModal);
  };
  return (
    <SideModal
      closeBtnVariant='side'
      bodyClassName='w-[98vw] sm:w-[450px]'
      showTopNavbar
      title={
        <div className='flex justify-between items-center '>
          <div>
            <p className='text-[20px] text-[#2E3031] font-medium'>Roles</p>
            <p className='text-[#6F7376]'>Assign and manage admin access</p>
          </div>
          <button className='text-[#E60A2B] font-medium mr-6' onClick={addRoleModal}>
            {' '}
            + Add{' '}
          </button>
        </div>
      }
      isOpen={isOpen}
      onRequestClose={onClose}>
      <div className='my-[40px]'>
        {loading ? (
          <div className='flex justify-center items-center h-[300px]'>
            <p>Loading....</p>
          </div>
        ) : adminList.length === 0 ? (
          <div className='flex justify-center items-center h-[300px]'>
            <p>No member has been assigned as admin</p>
          </div>
        ) : (
          adminList.map((admin: MemberListType) => (
            <div key={admin.id} className='flex justify-between items-center my-6'>
              <p>{getFullName(admin.user)}</p>
              <button
                onClick={() => {
                  setActiveAdmin(admin);
                  removeAdmin();
                }}
                className='w-[86px] h-[34px] rounded-[100px] bg-[#F2F2F2] hover:bg-gray-4 font-medium text-xs text-gray-9'>
                Remove
              </button>
            </div>
          ))
        )}
        {showRemoveModal && activeAdmin && (
          <DeletePeople
            onClose={() => {
              removeAdmin();
            }}
            show={showRemoveModal}
            activeMember={activeAdmin}
            isAdmin
            onRefetch={fetchAdminList}
          />
        )}
      </div>
      <AddRole show={showAddModal} onClose={addRoleModal} updateAdminList={updateAdminList} />
    </SideModal>
  );
};

export default ManageRoleModal;
